import { Component, ReactNode, FormEvent, MouseEvent } from 'react'

import { BLOG_URL, LOGIN_URL } from '../../confs/costants'

import { UserType } from '../../slices/LoginSlice'

import Modal from './Modal'

import { isValidEmail } from '../../utils/stringValidation'
import { createToken, deleteToken } from '../../utils/manageToken'


export interface Props {
    isOpen: boolean                 // indica se la modale è aperta
    updateUserCallBack: Function    // funzione per loggare l'utente
    switchModalCallBack: Function   // apre la modale di rigestrazione
    closeModalCallBack: Function    // funzione per chiudere la modale
}

export interface State {
    isLoading: boolean
    loginMail: string
    loginPass: string
    loginError: string | undefined
}

class LoginModal extends Component<Props,State> {

    constructor (props: any) {
        super(props)

        this.state = {
            loginError: undefined,
            loginMail: '',
            loginPass: '',
            isLoading: false
        }

        this.updateLoginMail = this.updateLoginMail.bind(this)
        this.updateLoginPass = this.updateLoginPass.bind(this)

        this.login = this.login.bind(this)

        this.exit = this.exit.bind(this)
        this.switchModal = this.switchModal.bind(this)
    }

    componentWillUnmount(): void {
        this.setState({
            loginError: undefined,
            loginMail: '',
            loginPass: '',
            isLoading: false
        })
    }

    render(): ReactNode {
        return (
            <>
                <Modal
                    id="login"
                    titleText="Che bello rivederti!"
                    isOpen={this.props.isOpen}
                    closeModalCallBack={this.exit}
                >
                    <>
                        <p className='instructions'>
                            Effettua il login per accedere a tutti i vantaggi della tua area personale.
                        </p>

                        { this.state.loginError !== undefined &&
                            <p className='error'>
                                { this.state.loginError }
                            </p>
                        }

                        <div className='form-input-contaier'>
                            <label htmlFor='loginMail'>E-mail *</label>
                            <input 
                                id='loginMail'
                                name='login_mail'
                                type='email'
                                value={this.state.loginMail}
                                onChange={this.updateLoginMail}
                            />
                        </div>

                        <div className='form-input-contaier'>
                            <label htmlFor='loginPass'>Password *</label>
                            <input 
                                id='loginPass'
                                name='login_pass'
                                type='password'
                                value={this.state.loginPass}
                                onChange={this.updateLoginPass}
                            />
                        </div>

                        <p>
                            <a 
                                target="_blank"
                                href={ BLOG_URL + 'preventivi/area-personale/password-dimenticata/' }
                                rel="noreferrer"
                            >
                                Hai dimenticato la password?
                            </a>
                        </p>

                        <div className='form-input-contaier'>
                            <button
                                disabled={this.state.isLoading}
                                onClick={this.login}
                            >
                                Accedi {this.state.isLoading ? '...' : ''}
                            </button>
                        </div>

                        <p className='center instructions pt1'>
                            <a
                                target="_blank"
                                href={ BLOG_URL + 'nostri-contatti/' }
                                rel='noreferrer'
                            >
                                Hai bisogno di aiuto? Contattaci
                            </a>
                            <br/>
                            Non hai ancora un account?
                            <br/>
                            <a
                                href='#'
                                rel='noreferrer'
                                onClick={this.switchModal}
                            >
                                Registrati
                            </a>
                        </p>
                    </>
                </Modal>
            </>
        )
    }

    private exit () {
        this.setState({
            loginError: undefined,
            loginMail: '',
            loginPass: '',
            isLoading: false
        }, () => {
            this.props.closeModalCallBack()
        })
    }

    private switchModal (e: MouseEvent<HTMLAnchorElement>) {
        e.preventDefault()
        e.stopPropagation()

        this.setState({
            loginError: undefined,
            loginMail: '',
            loginPass: '',
            isLoading: false
        }, () => {
            this.props.switchModalCallBack()
        })
    }

    private login () {
        if ( !isValidEmail( this.state.loginMail ) ) {
            this.setState ({
                loginError: 'Controllare di aver riempito i campi e riprovare.'
            })
        }
        else {
            const requestHeaders: HeadersInit = new Headers()
            requestHeaders.append('Origin', 'https://www.6sicuro.it')
            requestHeaders.append('Referer', 'https://www.6sicuro.it/')
            requestHeaders.append('Content-Type', 'application/json; charset="utf-8"')

            this.setState({
                isLoading: true
            }, () => {

                fetch (
                    LOGIN_URL,
                    {
                        method: "POST",
                        headers: requestHeaders,
                        body: JSON.stringify({
                            email: this.state.loginMail,
                            password: this.state.loginPass
                        })
                    }
                )
                .then ( (response) => {
                    if (!response.ok) {
                        let err = new Error("HTTP status code: " + response.status)
                        throw err
                    }
                    
                    createToken( response.headers )

                    return response.json()
                })
                .then ( (user: UserType) => {

                    // response OK
                    this.props.updateUserCallBack( user )

                })
                .catch ( (err) => {
                    console.log(err)

                    this.setState ({
                        loginError: 'Login errato, riprovare.'
                    }, () => {
                        deleteToken()

                        this.props.updateUserCallBack( undefined )
                    })

                })
                .finally ( () => {
                    this.setState({
                        isLoading: false
                    })
                })
                
            })

        }
    }

    private updateLoginMail (e: FormEvent<HTMLInputElement>) {
        e.stopPropagation()

        this.setState ({
            loginError: undefined,
            loginMail: e.currentTarget.value ?? ''
        })
    }

    private updateLoginPass (e: FormEvent<HTMLInputElement>) {
        e.stopPropagation()

        this.setState ({
            loginError: undefined,
            loginPass: e.currentTarget.value ?? ''
        })
    }
    

}

export default LoginModal